
import { PayPalButton as component } from '../../components/editor/PayPalButton'

export const PayPalButton = {
  label: 'PayPal Donation Button',
  component,
  fields: [
    {
      name: 'label',
      label: 'Label',
      widget: 'string',
      default: 'Donate Now with PayPal'
    }
  ]
}
